module.exports = __webpack_public_path__ + "public/images/animals-and-wildlife.483edb467e85d3a440bca4ee3afdf371.jpg";